import { Grid, Skeleton } from '@mui/material'
import React from 'react'

const FormSkeleton = () => {
  return (
    <div style={{ padding: '2px', maxWidth: '600px', margin: '0 auto' }}>
      <Skeleton variant="rectangular" height={30} width={200} sx={{ mb: 1 }} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Skeleton variant="rounded" height={56} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rounded" height={56} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rounded" height={100} />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Skeleton variant="rounded" height={30} width={150} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rounded" height={30} />
        </Grid>
      </Grid>
    </div>
  )
}

export default FormSkeleton;
